import { render, staticRenderFns } from "./uploadfailed.vue?vue&type=template&id=ec4cff14&"
import script from "./uploadfailed.vue?vue&type=script&lang=js&"
export * from "./uploadfailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports